import campaignConfig from '../../campaign-config/campaign.json';
import pointsIcon from '../../assets/images/pts.png';

export const globalColors = campaignConfig.global?.colors || {};
export const globalText = campaignConfig.global?.text || {};
export const globalImages = campaignConfig.global?.images || {};

const localWebAssets = {
	'src/assets/images/pts.png': pointsIcon,
};

export const tutorWebConfig = campaignConfig.tutor_web || {};

export const resolveTutorWebAsset = (asset) =>
	localWebAssets[asset] || asset;
